module.exports = __webpack_public_path__ + "static/media/MU.2d399ae0.png";